import { Box, Button, Card, Chip, Grid, IconButton, InputAdornment, Modal, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Controller, set, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
// import { CustomerService } from '../Service';
import { LocalStore } from '../../../../storage/authStore';
// import WalletTransactions from './WalletTransactions';
import { PermissionGuard } from '../../../../components/PermissionGuard';
import { ProviderServices } from '../../CrudServices';
import WalletTransactions from './WalletTransactions';
import ImgUploadDialog from '../../../../components/ImgUpload/imgUpload';
import { AddToPhotos, Close, FitScreen, ZoomIn, ZoomOut } from '@mui/icons-material';
import { Helpers } from '../../../../services/Helpers';

const WalletDetails = ({walletData,fetchData}) => {
    const {id} = useParams();
    const [addBalance,setAddBalance] = useState(false);
    const [deductBalance,setDeductBalance] = useState(false);
    const [refreshTransactionList,setRefreshTransactionList] = useState(false);
    const [walletDetails,setWalletDetails] = useState(null);

    const initialState = {
        expertId: id,
        amount: 0,  
        title:'' ,
        paymentId :'',
        comment :'',
    };
    const {control,watch,setValue,handleSubmit,reset} = useForm({
        mode:'onChange',
        defaultValues: initialState,
    });
    const amount = watch('amount');
    useEffect(() => {
        if (amount>0) {
            setValue('title',` ₹ ${amount}  ${addBalance?'Added in Wallet':'Deducted from Wallet'}  `);
        }else{
            setValue('title',` ₹ 0  ${addBalance?'Added in Wallet':'Deducted from Wallet'}  `);
        }
    }, [amount]);
    const onSubmit = async(data)=>{
        console.log("data",data);
        const modifiedData = {
            expertId: data.expertId,
            amount: data.amount,
            title: data.title,
            paymentId: data.paymentId,
            comment: data.comment,
            image: data.image,
        }
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to ${addBalance ? 'add' : 'deduct'} wallet balance?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Add now!',
            cancelButtonText: 'No, Cancel',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCloseButton: false,
        });
        if(result.isConfirmed){
            try {
                // Show loading state
                Swal.fire({
                    title: 'Please wait...',
                    html: 'Updating Wallet Balance',
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
                let submitResponse = {};
                if(deductBalance){
                    submitResponse = await ProviderServices.deductMoneyFromWallet(modifiedData);
                }else{
                    submitResponse = await ProviderServices.addMoneyToWallet(modifiedData);
                }
                console.log("submitResponse",submitResponse);
                if (submitResponse.success == '1') {
                    Swal.fire({
                        title: 'Success',
                        text: `Wallet balance updated successfully`,
                        icon: 'success',
                        timer: 1500
                    });
                    fetchWalletDetails();
                    setRefreshTransactionList(true);
                    resetAll();
                    return true;
                }else{
                    console.log("submitResponse",submitResponse);
                    Swal.fire({
                        title: 'Error',
                        text: submitResponse.message || 'Failed to add Cudel Coins',
                        icon: 'error',
                    });
                }
            } catch (error) {
                console.error('Error updating SAC code:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'Failed to update SAC code',
                    icon: 'error',
                });
            }
        }

    }
    const resetAll = () => {
        reset(initialState);
        setAddBalance(false);
        setDeductBalance(false);
        setImageUploadResponseDetails({});
    }
    const fetchWalletDetails = async() => {
        const response = await ProviderServices.getwalletDetails(id);
        console.log("response",response);
        if (response.success == '1') {
            setWalletDetails(response.data);
        }
    }
    useEffect(() => {
        fetchWalletDetails();
    }, []);
    const selectWalletTransactionType = (type) => {
        reset(initialState);
        if (type === 'addBalance') {
            setAddBalance(true);
            setDeductBalance(false);
        }else if (type === 'deductBalance') {
            setDeductBalance(true);
            setAddBalance(false);
        }
    }
    /*================== image upload realted ====================== */
      const [imageUploadResponseDetails, setImageUploadResponseDetails] = useState({});
      const [imgModalOpen, setImgModalOpen] = useState(false);
    
      const openImgModal = () => {
          setImgModalOpen(true);
      };
    
      const closeModal = () => {
          setImgModalOpen(false);
      };
    
      const imgData = {
          path: 'expert-wallet',
          img_type: "single"
      };
      const imgUploadResponse = (data) => {
          setImageUploadResponseDetails(data);
          setValue('image', data.imageName, { shouldDirty: true, shouldValidate: true });
      }
      
  return (
    <Grid item xs={12}>
        <Card sx={{mb:'1%'}}>
          <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
              <Typography sx={{fontWeight:'600',fontSize:'0.85rem'}}>Wallet Detail's</Typography>
          </Box> 
          
            <Box sx={{p:'1%',display:'flex',justifyContent:'space-between'}}>
                <Box sx={{display:'flex',gap:1}}>
                    <Typography sx={{fontWeight:600,fontSize:'0.75rem',textAlign:'center'}}>Current Balance : </Typography>
                    <Chip label={`₹ ${walletDetails?.currentBalance || 0.00}`} sx={{fontSize:'0.75rem'}} color={walletDetails?.currentBalance > 0 ? 'success' : 'error'} size='small'/> 
                    {/* <Typography sx={{fontWeight:600,fontSize:'0.75rem',textAlign:'center'}}>₹ {walletDetails?.currentBalance || 0.00}</Typography> */}
                </Box>
                <PermissionGuard feature='expert-wallet-management' permission='canEdit'>
                    <Box sx={{display:'flex',gap:1,width:{xs:'100%',sm:'30%'}}}>
                        <Button size='small' variant="contained" color="primary" sx={{width:'100%',fontSize:'0.75rem',fontWeight:600,textTransform:"capitalize"}} onClick={()=>selectWalletTransactionType('deductBalance')}>Deduct Balance</Button>
                        <Button size='small' variant="contained" color="primary" sx={{width:'100%',fontSize:'0.75rem',fontWeight:600,textTransform:"capitalize"}} onClick={()=>selectWalletTransactionType('addBalance')}>Add Balance</Button>
                    </Box>
                </PermissionGuard>
            </Box>
            { (addBalance || deductBalance) &&            
                <Box component={'form'} sx={{p:'1%'}} onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={5} sx={{pt:'0%!important'}}>
                        <Grid item xs={12} sm={5}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem'}}>
                                        {addBalance ? 'Add' : 'Deduct'} Amount<span style={{color:'#d32f2f'}}>*</span> 
                                    </Typography>
                                    <Controller
                                        control={control}
                                        name="amount"
                                        rules={{
                                            required:'Enter Amount',
                                            validate: (value) => {
                                                //value should be greater than 0
                                                if (value <= 0) return 'Amount should be greater than 0';
                                                return true;
                                            }
                                        }}
                                        render={({field,fieldState:{error}})=>(
                                            <TextField
                                                {...field}
                                                size='small'
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                        <Typography color="text.secondary" sx={{fontSize:'0.65rem'}}>
                                                            ₹
                                                        </Typography>
                                                        </InputAdornment>
                                                    ),
                                                    style:{fontSize:'0.65rem'},
                                                    onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                                    onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused
                                                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                                    onKeyDown: (e) => {
                                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                        }
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    let finalValue;
                                                    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {                                
                                                    finalValue = formatValue(inputValue);
                                                        if(finalValue==''){
                                                            finalValue=0
                                                        }
                                                        field.onChange(finalValue);
                                                    }
                                                }}
                                                
                                                fullWidth
                                                error={error}
                                            />                                            
                                        )}
                                    />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem'}}>Payment Id</Typography>
                            
                                <Controller
                                    control={control}
                                    name="paymentId"
                                    rules={{
                                        // required:'Enter Payment ID',
                                        // validate: (value) => {
                                        //     if (value.trim().length === 0) return 'Payment ID is required';
                                        //     return true;
                                        // }
                                    }}
                                    render={({field,fieldState:{error}})=>(
                                        <TextField
                                            {...field}
                                            size='small'
                                            inputProps={{style:{fontSize:'0.65rem'}}}
                                            fullWidth
                                            error={error}
                                        />
                                    )}
                                />
                            </Grid>
                            {/* <Grid item xs={12}>
                                <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem'}}>Title</Typography>
                            
                                <Controller
                                    control={control}
                                    name="title"
                                    rules={{
                                        // required:'Enter Title',
                                        // validate: (value) => {
                                        //     if (value.trim().length === 0) return 'Title is required';
                                        //     return true;
                                        // }
                                    }}
                                    render={({field,fieldState:{error}})=>(
                                        <TextField
                                            disabled
                                            {...field}
                                            size='small'
                                            inputProps={{style:{fontSize:'0.65rem'}}}
                                            fullWidth
                                            error={error}
                                        />
                                    )}
                                />
                            </Grid> */}
                            <Grid item xs={12}>
                                <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem'}}>Comment <Box component="span" sx={{color:'red'}}>*</Box></Typography>
                            
                                <Controller
                                    control={control}
                                    name="comment"
                                    rules={{
                                        required:'Enter Comment',
                                        // validate: (value) => {
                                        //     if (value.trim().length === 0) return 'Comment is required';
                                        //     return true;
                                        // }
                                    }}
                                    render={({field,fieldState:{error}})=>(
                                        <TextField
                                            {...field}
                                            size='small'
                                            inputProps={{style:{fontSize:'0.65rem'}}}
                                            multiline
                                            rows={3}
                                            fullWidth
                                            error={error}
                                        />
                                    )}
                                />
                            </Grid>
                            </Grid>
                        </Grid>
                        
                        <Grid item xs={12} sm={4}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem'}}>
                                    Image 
                                </Typography>
            
                                <Box sx={{ textAlign: 'center'}}>
                                    <Box sx={{height: '11rem',border:'1px dashed gray',borderRadius:'4px',mb:1}}>                        
                                    {(imageUploadResponseDetails.imageName) && (
                                        <Box
                                        sx={{
                                            position: 'relative',
                                            width: '100%',maxWidth: '100%' ,maxHeight:'100%',
                                            overflow: 'hidden',
                                            '&:hover .overlay': {
                                            opacity: 1,
                                            },
                                        }}
                                        >
                                        <img
                                            src={`${Helpers.ImagePathUrl()}/expert-wallet/${imageUploadResponseDetails.imageName}`}
                                            alt="Uploaded"
                                            style={{ maxWidth: '100%' ,maxHeight:'100%', display: 'block', margin: '0 auto' }}
                                        />
                                        
                                        
                                        </Box>
                                    )}
                                    </Box>
            
                                    <Button
                                        onClick={openImgModal}
                                        // disabled={isSubmitting}
                                        variant="outlined"
                                        startIcon={<AddToPhotos />}
                                        size="small"
                                        fullWidth
                                    >
                                        {imageUploadResponseDetails.imageName ? 'Change Image' : 'Select Image'}
                                    </Button>
                                </Box>
            
                                <Controller
                                    control={control}
                                    name='image'
                                    rules={{
                                        // required: (paymentMethod!== 'APP_RAZORPAY'&& paymentMethod!== 'CASH') && 'Please upload an image' 
                                    }}
                                    render={({ fieldState: { error } }) => (
                                        error && (
                                            <Typography color="error" variant="caption" display="block" textAlign="center">
                                                {error.message}
                                            </Typography>
                                        )
                                    )}
                                />
                                </Grid>
                            </Grid>
                            </Grid>
                        <Box sx={{display:'flex',justifyContent:'center',gap:2,alignItems:'center',width:'100%',p:'1%'}}>
                            <Button sx={{textTransform:'capitalize'}} variant='contained' color='primary' size='small' type='submit'>Submit</Button>
                            <Button sx={{textTransform:'capitalize'}} variant='contained' color='error' size='small' onClick={()=>resetAll()}>Cancel</Button>
                        </Box>
                    </Grid>
                </Box>                
            }
        </Card>
        <WalletTransactions refreshTransactionList = {refreshTransactionList} setRefreshTransactionList={setRefreshTransactionList}/>
        {/* ============== image upload dialog ============= */}
        <ImgUploadDialog open={imgModalOpen} onClose={closeModal}
            imgData={imgData}
            imgUploadResponse={imgUploadResponse}
        />
            
    </Grid>
  );
}

export default WalletDetails;
const formatValue = (value) => {
    if (!value) return '';  // Return empty string instead of 0
    const numValue = parseFloat(value);
    return isNaN(numValue) ? '' : numValue.toString();
}